import { createExperiment } from 'shared/experiment/hook';
import type { LotrExperiments } from '@/interfaces';

const { ExperimentProvider, useExperiment } = createExperiment<LotrExperiments>();

export { ExperimentProvider, useExperiment };
